/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Lib dependencies
import React from 'react';
import { Box } from '@mantine/core';
import clsx from 'clsx';

// Styles
import classes from './VerifiedButton.module.css';

/* -------------------------------------------------------------------------- */
/*                                    Types                                   */
/* -------------------------------------------------------------------------- */
type TVerifiedButtonProps = {
	onClick?: (
		event: React.MouseEvent<HTMLElement>
	) => void;
	children: string;
	size?: string;
	variant?: string;
	color?: string;
	fullWidth?: boolean;
	loading?: boolean;
	disabled?: boolean;
	leftSection?: React.ReactNode;
	isverified: string | undefined | boolean;
	readOnly?: boolean;
};

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
export const VerifiedButton = (
	props: TVerifiedButtonProps
) => {
	const { children, ...restProps } = props;
	/* ******************************** RENDERING ******************************* */
	return (
		<Box
			className={clsx([
				classes.root,
				props.isverified
					? classes.verified
					: classes.unverified,
				props.readOnly && classes.readOnly,
			])}
			{...restProps}
		>
			{children}
		</Box>
	);
};
